import { render, staticRenderFns } from "./TextareaInput.vue?vue&type=template&id=4a7d4c02&"
import script from "./TextareaInput.vue?vue&type=script&lang=js&"
export * from "./TextareaInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports